<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-07 19:00:42
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-23 12:20:58
 * @FilePath: \ioc_base\src\components\common\gis\components\circle.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="range" :style="{
        width:option.width+'px',
        height:option.height+'px',
    }
    ">
    </div>
  </div>
</template>

<script>
export default {
  name: "circle-range", //地图范围效果组件，通过挂载展示
  data() {
    return {
      option: {
        width:200,
        height:200,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.range {
//   width: 200px;
//   height: 200px;
  border-radius:50%;
  background:radial-gradient(rgba(62, 118, 229,0.1),rgba(62, 118, 229,0.6)) ;
  position: absolute;
  text-align:center;
  padding-top:20px;
  color:transparent;
  pointer-events: none;
}
</style>
